<template lang="html">
  <div class="cover-popup row-center">
    <div class="popup">
      <div class="contenedor-botones">
          <!-- <button class="btn-close" @click="cerrarPopup">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="#376bae" d="M345 137c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-119 119L73 103c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l119 119L39 375c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l119-119L311 409c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-119-119L345 137z"/></svg>
          </button> -->
      </div>
      <h2 class="title-pop">{{ $t('popup_pedir_naf.titulo') }}</h2>

      <p>{{ $t('popup_pedir_naf.subtitulo') }}</p>

      <p style="margin-left: 20px;">{{ $t('popup_pedir_naf.parrafo1') }}</p>

      <!-- <p style="margin-left: 20px;">{{ $t('popup_pedir_naf.parrafo2') }}</p> -->

      <p></p>

      <p>{{ $t('popup_pedir_naf.pie')}}</p>

      <div class="contenedor-botones">

        <button class="btn  -solid-primary" @click="irACV">{{ $t('popup_pedir_naf.ir') }}</button>

      </div>

    </div>
  </div>
</template>

<script lang="js">

import { mapGetters, mapActions } from 'vuex';
import router from '@/router'

export default {
  name: 'popup-pedir-NAF',
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters({
      brand: 'getBrand',
      style: 'getStyles'
    })
  },
  methods: {
    ...mapActions(['erasePedirNAF']),
    irACV() {
      this.$router.push('/cv');
    },
    cerrarPopup() {
      this.erasePedirNAF();
    }
  }
}
</script>
<style scoped lang="scss">
.btn-close{
  background: transparent;
  border: 0;
  cursor: pointer;
  position: absolute;
  right: 0;
  top:15px;
  svg{
    width: 100%;
    max-width: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/popup-pedir-NAF.vue